<div [class]="containerClasses">
  <ng-container *ngIf="buttonStyle === 'text'; else buttonTemplate">
    <span
      [id]="id"
      class="text-button"
      [ngClass]="{ disabled: disabled }"
      (click)="onClick()">
      {{ buttonText | translate }}
      <div *ngIf="statusClass === 'fetching'" class="spinner-inline">
        <div class="spinner-border-sm" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
      <i
        *ngIf="statusClass === 'success'"
        class="check-icon fas fa-check-circle"></i>
    </span>
  </ng-container>
  <ng-template #buttonTemplate>
    <button
      [id]="id"
      [class]="buttonClasses"
      [disabled]="disabled || statusClass === 'fetching'"
      (click)="onClick()">
      <div class="button-content">
        <span>{{ buttonText | translate }}</span>
        <div *ngIf="statusClass === 'fetching'" class="spinner-container">
          <div class="spinner-border-sm" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
        <i
          *ngIf="statusClass === 'success'"
          class="check-icon fas fa-check-circle"></i>
      </div>
    </button>
  </ng-template>
</div>
